import React, { useState } from 'react';

import { numberWithComma, decimalPlace2 } from 'src/utils/Utils';
import styles from './PayrollTableData.scss';
import Row from './Row';
import AccordionRow from './AccordionRow';
import BoldRow from './BoldRow';
import { useTranslation } from 'react-i18next';

const getAllowanceItems = payroll =>
  payroll.employeePayAllowances.filter(item => item.allowanceType === 'payment');


const getBasicSalary = payroll => getAllowanceItems(payroll).find(item => item.name === '基本給');

const getAllowanceItemsWithoutBasicSalary = payroll =>
  getAllowanceItems(payroll).filter(item => item.name !== '基本給');

const PayrollAllowanceDetail = ({ payroll}) => {

  const { t } = useTranslation();
  const [isTaxableClick, setIsTaxableClick] = useState(false)
  const [isNonTaxableClick, setIsNonTaxableClick] = useState(false)
  const taxableItems = payroll.earnings.find(taxableItems => taxableItems.label == 'Taxable')
  const nonTaxableItems = payroll.earnings.find(nonTaxableItems => nonTaxableItems.label == 'Non taxable')
  const nonTaxable = payroll.earnings.find(nonTaxable => nonTaxable.label == 'Non taxable')
  const taxable = payroll.earnings.find(taxable => taxable.label == 'Taxable')
  const totalPayment = payroll.earnings.find(totalPayment => totalPayment.label == 'Total earning')
  const taxableHandler = () => {
    setIsTaxableClick(prev => !isTaxableClick);
  }  

  const nonTaxableHandler = () => {
    setIsNonTaxableClick(prev => !isNonTaxableClick);
  }  

  const taxableStyling = isTaxableClick ? {display: "contents"} : {display: "none"}
  const nonTaxableStyling = isNonTaxableClick ? {display: "contents"} : {display: "none"}
  return (
    <div className={styles.paymentClm}>
      {payroll && (
        <table className="m-table-obvious">
          <thead>
            <tr>
              <th colSpan="2">{t('features.MyData.components.payroll.PayrollAllowanceDetail.payment')}</th>
            </tr>
          </thead>
          <tbody>
            <AccordionRow
              label={t('features.MyData.components.payroll.PayrollAllowanceDetail.taxable')}
              value={numberWithComma(decimalPlace2(taxable.value))}
              isRowClick={isTaxableClick}
              accordionHandler={taxableHandler}
            />
          </tbody>
          <tbody style={taxableStyling}>
            {(taxableItems.description).map(taxableItem => (
              <Row key={taxableItem.id} label={taxableItem.label} value={numberWithComma(decimalPlace2(taxableItem.value))} />
            ))}
          </tbody>
          <tbody>
            <AccordionRow
              label={t('features.MyData.components.payroll.PayrollAllowanceDetail.non_taxable')}
              value={numberWithComma(decimalPlace2(nonTaxable.value))}
              isRowClick={isNonTaxableClick}
              accordionHandler={nonTaxableHandler}
            />
          </tbody>
          <tbody style={nonTaxableStyling}>
            {(nonTaxableItems.description).map(nonTaxableItem => (
              <Row key={nonTaxableItem.id} label={nonTaxableItem.label} value={numberWithComma(nonTaxableItem.value)} />
            ))}
          </tbody>
          <tbody>
            <BoldRow
              label={t('features.MyData.components.payroll.PayrollAllowanceDetail.total_payment')}
              value={numberWithComma(decimalPlace2(totalPayment.value))}
              accordion
            />
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PayrollAllowanceDetail;
